
























import Vue from "vue";
import ChoiceSelectOption from "./ChoiceSelectOption.vue";
import { SelectOption, SelectOptionKey } from "../types";
import isNil from "lodash/isNil";
import flatten from "lodash/flatten";

export default Vue.extend({
  props: {
    name: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: (): boolean => false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: (): boolean => false
    },
    choices: {
      type: Array as () => SelectOption[],
      required: true
    },
    value: {
      required: true
    },
    minChoices: {
      type: Number,
      required: false,
      default: (): null => null
    }
  },

  computed: {
    selectedChoices(): SelectOption[] {
      return this.choices.filter(c => flatten([this.value]).includes(c.key));
    },

    /**
     * A choice like 'Other' for the subjects profile field should not be submitted
     * to the backend, so it's value is explicitly NULL.
     */
    selectedChoicesForSubmission(): SelectOption[] {
      return this.selectedChoices.filter(
        (option: SelectOption) => !isNil(option.value)
      );
    }
  },

  methods: {
    isSelected(choice: SelectOption): boolean {
      return this.selectedChoices.includes(choice);
    },

    updateSelection(key: SelectOptionKey, selected: boolean) {
      if (
        !selected &&
        this.minChoices !== null &&
        this.selectedChoices.length - 1 < this.minChoices
      ) {
        // do nothing; the deselection is disallowed because it would leave the
        // # selected choices less than the min limit specified.
        return;
      }

      if (this.multiple) {
        if (selected) {
          this.$emit(
            "input",
            Array.from(new Set(this.selectedChoices.map(c => c.key)).add(key)),
            key,
            true
          );
        } else {
          this.$emit(
            "input",
            this.selectedChoices
              .map((c: SelectOption) => c.key)
              .filter((k: SelectOptionKey) => k !== key),
            key,
            false
          );
        }
      } else {
        this.$emit("input", selected ? key : null, key, selected);
      }
    }
  },

  components: {
    ChoiceSelectOption
  }
});
